__turbopack_context__.v({
  "buttonOtherFilter": "styles-module__V0UlFW__buttonOtherFilter",
  "dinamycSearch": "styles-module__V0UlFW__dinamycSearch",
  "filterBlock": "styles-module__V0UlFW__filterBlock",
  "inputRangeBlock": "styles-module__V0UlFW__inputRangeBlock",
  "lastBlock": "styles-module__V0UlFW__lastBlock",
  "selectBlock": "styles-module__V0UlFW__selectBlock",
});
